//service.js
import { data } from 'jquery';
import service from './axios'

let development = process.env.NODE_ENV == 'development' ? true : false;
let baseURL = '/'
if(development){
	baseURL = 'http://localhost:82/'
}

export let GetBaseURL = baseURL

export const Register = data => {
	return service({
		url: '/register',
		method: 'post',
		data
	})
};
// 发送验证码
export const SendSms = data => {
	return service({
		url: '/send_sms',
		method: 'post',
		data
	})
};
// 会员登录
export const Login = data => {
	return service({
		url: '/login',
		method: 'post',
		data
	})
};
// 专家登录
export const loginexpert = data => {
	return service({
		url: '/expert/login',
		method: 'post',
		data
	})
};
// 发送忘记密码验证码
export const SendForgetSms = data => {
	return service({
		url: '/send_forget_password_sms',
		method: 'post',
		data
	})
};
// 忘记密码提交
export const ForgetPassword = data => {
	return service({
		url: '/forget_password',
		method: 'post',
		data
	})
};
export const ChangePhone = data=>{
    return service({
        url: '/change_phone',
        method: 'post',
        data
    })
}
// 用户信息
export const GetMember = data => {
	return service({
		url: '/info',
		method: 'get',
		data
	})
};
// 专家登录信息
export const expertinfo = data => {
	return service({
		url: '/expert/info',
		method: 'get',
		data
	})
};
// 专家修改密码
export const expertModifyPwd = data => {
	return service({
		url: '/expert/modifypwd',
		method: 'post',
		data
	})
};
// 更新用户信息
export const UpdataMember = data => {
	return service({
		url: '/user',
		method: 'PUT',
		data:data
	})
};
// 奖项管理列表
export const PrizeList = data => {
	console.log(data)
	return service({
		url: '/prize',
		method: 'get',
		data
	})
};
// 新增奖项
export const AddPrize = data => {
	return service({
		url: '/prize',
		method: 'POST',
		data
	})
};
// 删除奖项
export const DelatePrize = id => {
	return service({
		url: '/prize/' + id,
		method: 'DELETE',

	})
};
// 申请会员
export const Apply = data => {
	return service({
		url: '/apply',
		method: 'POST',
		data:data,
	})
};
// 会员信息
export const ApplyInfo = data => {

	return service({
		url: '/apply/info',
		method: 'GET',
		data
	})
};
// 申请会员缴费
export const ApplyPayment = id => {
	return service({
		url: '/order/apply/' + id,
		method: 'POST',
	})
};
// 缴费记录
export const Order = data => {
	return service({
		url: '/order',
		method: 'GET',
		data
	})
};
//会员续费
export const renewOrder = id => {
	return service({
		url: '/order/renew',
		method: 'POST'
	})
};
// 订单信息
export const myOrder = id => {
	return service({
		url: `/order/${id}`,
		method: 'GET',
	})
};
// 奖项列表
export const AwardList = data => {
	return service({
		url: '/award',
		method: 'GET',
		data
	})
};
export const AwardListWithCount = data => {
	return service({
		url: '/awardCount',
		method: 'GET',
		data
	})
};
// 申报记录详情
export const AwardInfo = id => {
	return service({
		url: '/award_log/' + id,
		method: 'GET',
	})
};
export const AwardInfobatch = (id,award_batch_id) => {
	return service({
		url: '/award_log/' + id+'?award_batch_id='+award_batch_id,
		method: 'GET',
	})
};
export const AwardInfoList = data => {
	return service({
		url: '/award_log',
		method: 'GET',
		data
	})
};
// 申报奖项
export const AwardLog = data => {
	return service({
		url: '/award_log',
		method: 'POST',
		data
	})
};
// 申报奖项填写地址
export const Address = (id, address) => {

	return service({
		url: '/award_log/address/' + id,
		method: 'POST',
		data: {
			address
		}
	})
};

// 业绩申报列表
export const AchievementReport = data => {
	return service({
		url: '/achievement_report',
		method: 'GET',
		data
	})
};
// 申报业绩
export const AddAchievementReport = data => {
	return service({
		url: '/achievement_report',
		method: 'POST',
		data
	})
};
export const HighqualityReport = data => {
    return service({
        url: '/highquality_report',
        method: 'GET',
        data
    })
};
// 申报业绩
export const AddHighqualityReport = data => {
    return service({
        url: '/highquality_report',
        method: 'POST',
        data
    })
};
// 消息通知列表
export const Message = data => {
	return service({
		url: '/message',
		method: 'GET',
		data
	})
};
// 标记已读, 不传标记全部, 传id则标记部分
export const MessageRead = data => {
	return service({
		url: '/message/read',
		method: 'POST',
		data
	})
};
// 申请发票
export const Invoice = (id, data) => {
	return service({
		url: '/invoice/' + id,
		method: 'POST',
		data
	})
};
//保存草稿
export const SaveDraft = (id, data, award_batch_id) => {
	return service({
		url: '/award_log_temp',
		method: 'POST',
		data: {
			award_id: id,
			content: data,
			award_batch_id
		}
	})
};


export const SaveBDraft = (id, data,award_batch_id=0) => {
	return service({
		url: '/award_log_temp',
		method: 'POST',
		data: {
			award_id: id,
			content: data,
			award_batch_id:award_batch_id
		}
	})
};
//保存草稿记录
export const Draftrecord = (id,award_batch_id) => {
	return service({
		url: '/award_log_temp/' + id+'?award_batch_id='+award_batch_id,
		method: 'GET'
	})
};
//保存草稿记录
export const Draftrecord2 = (id) => {
	return service({
		url: '/award_log_temp/edit/' + id,
		method: 'GET'
	})
};
const buildGongfaSubmitFields = (id, data) => {
	if (Number(id) !== 21 || !data || !data.info) return {}

	const info = data.info
	return {
		register_province: String(info.gf_province) === '2' ? info.gf_province_detail : undefined,
		authorize_publicity: info.text_public_authorized
	}
}

//申报
export const Declare = (id, data,rId=null,batchId=null) => {
	return service({
        url: "/award_log",
        method: "POST",
        data: {
            id: rId,
            award_id: id,
            content: data,
			award_batch_id:batchId,
			...buildGongfaSubmitFields(id, data)
        }
    });
};
//申报驳回的
export const Declare_modify = (rId,id, data,batchId=null) => {
	if(rId&&rId!=0){
		return service({
			url: '/award_log',
			method: 'POST',
			data: {
				id:rId,
				award_id: id,
				content: data,
				award_batch_id:batchId,
				...buildGongfaSubmitFields(id, data)
			}
		})
	}
	else{
		return Declare(id,data,rId,batchId);
	}
};
//申报记录详情
export const DeclareDetails = (id) => {
	return service({
		url: '/award_log/show/' + id,
		method: 'GET'
	})
};
export const DeclareDetailsgf = (id,clid) => {
	return service({
		url: '/award_log/show/' + id+'?clid='+clid,
		method: 'GET'
	})
};
//申报记录删除
export const DeclareDestory = (id) => {
	return service({
		url: '/award_log/destory/' + id,
		method: 'GET'
	})
};
//会员申请保存草稿
// 工法申报记录自主撤回修改（待后端联调确认最终接口）
export const WithdrawAwardLog = (id) => {
	return service({
		url: '/award_log/withdraw/' + id,
		method: 'POST'
	})
};
export const Memberdraft = (content) => {
	return service({
		url: '/apply_member_temp',
		method: 'POST',
		data: {
			content: content
		}
	})
};
//会员申请查看草稿详情
export const Memberdraftdetail = (content) => {
	return service({
		url: '/apply_member_temp',
		method: 'GET'
	})
};
//专家端奖项列表
export const expertaward = (data) => {
	return service({
		url: '/expert/award',
		method: 'GET',
		data
	})
};
//专家端奖项评审列表
export const expertawardlogs = (id,data) => {
	return service({
		url: '/expert/award/logs/'+id,
		method: 'GET',
		data
	})
};

export const expertawardgflogs = (id,data) => {
	return service({
		url: '/expert/award/gflogs/'+id,
		method: 'GET',
		data
	})
};


//专家端评审记录详情列表
export const expertverifyLogs = (id,data) => {
	return service({
		url: '/expert/award/verifyLogs/'+id,
		method: 'GET',
		data
	})
};
//专家端评审审核是否通过
export const expertverify = (data,id) => {
	return service({
		url: '/expert/award/verify/'+id,
		method: 'POST',
		data
	})
};
//专家端评审记录详情列表
export const eprojectverifyLogs = (data) => {
	return service({
		url: '/expert/eproject/verifyLogs',
		method: 'GET',
		data
	})
};

export const expertgfverify = (data,id) => {
	return service({
		url: '/expert/award/gfverify/'+id,
		method: 'POST',
		data
	})
};

export const expertgfbverify = (data,ids) => {
	return service({
		url: '/expert/award/gfbverify/'+ids,
		method: 'POST',
		data
	})
};

export const expertAwardSummaryExport = (batchId, data = {}) => {
	return service({
		url: '/expert/award/export_summary/' + batchId,
		method: 'GET',
		data,
		responseType: 'blob'
	})
};

export const expertAwardScoreBatchExport = (ids) => {
	return service({
		url: '/review/award/batch_export_score',
		method: 'POST',
		data: {
			ids
		},
		responseType: 'blob'
	})
};


//专家端评审审核是否通过
export const eprojectverify = (data,id) => {
	return service({
		url: '/expert/eproject/verify/'+id,
		method: 'POST',
		data
	})
};

//会员申请表单详情
export const applydetail = (id) => {
	return service({
		url: '/apply/show/'+id,
		method: 'GET'
	})
};

//申请业绩申报列表
export const achievement = () => {
	return service({
		url: '/achievement',
		method: 'GET'
	})
};


//申请业绩申报详情
export const achievement_report = (id) => {
	return service({
		url: '/achievement_report/'+id,
		method: 'GET'
	})
};

//业绩申报草稿详情
export const achievement_report_temp_detail = (id) => {
	return service({
		url: '/achievement_report_temp/'+id,
		method: 'GET'
	})
};

//业绩申报草稿
export const achievement_report_temp = (data) => {
	return service({
		url: '/achievement_report_temp',
		method: 'POST',
		data
	})
};
//项目简况
export const highquality_report = (id) =>{
    return service({
        url: '/highquality_report/'+id,
        method: 'GET'
    })
}

export const highquality_report_temp_detail = (id) => {
    return service({
        url: '/highquality_report_temp/'+id,
        method: 'GET'
    })
};

export const highquality_report_temp = (data) => {
    return service({
        url: '/highquality_report_temp',
        method: 'POST',
        data
    })
};

//获取审核记录
export const checkedlogs = (id) => {
	return service({
		url: '/award_log/checkedlogs/'+id,
		method: 'GET'
	})
};

//第二次提交奖项资料
export const submitFile = (data,id) => {
	return service({
		url: '/award_log/submitFile/'+id,
		method: 'POST',
		data
	})
};
//黄果树补充材料
export const submitFileHgs = (data,id) => {
	return service({
		url: '/award_log/submitFileHgs/'+id,
		method: 'POST',
		data
	})
};

// 工程建设质量管理小组竞赛活动 - 提交专家评分
export const submitGroupScore = (data, id) => {
	return service({
		url: '/expert/award/score/'+id,
		method: 'POST',
		data
	})
};

// 工程建设质量管理小组竞赛活动 - 获取专家评分
export const getGroupScore = (id) => {
	return service({
		url: '/expert/award/score/'+id,
		method: 'GET'
	})
};

// 工程建设质量管理小组竞赛活动 - 检查是否重复
export const applyCheckedRepeat = (data) => {
	return service({
		url: '/award_log/checkRepeat',
		method: 'POST',
		data
	})
};

//专家申报
// 奖项列表
export const EprojectList = data => {
	return service({
		url: '/eproject',
		method: 'GET',
		data
	})
};
export const EprojectListWithCount = data => {
	return service({
		url: '/eprojectCount',
		method: 'GET',
		data
	})
};
// 申报记录详情
export const EprojectInfo = id => {
	return service({
		url: '/eproject_log/' + id,
		method: 'GET',
	})
};
export const EprojectInfobatch = (id,project_batch_id) => {
	return service({
		url: '/eproject_log/' + id+'?project_batch_id='+project_batch_id,
		method: 'GET',
	})
};
export const EprojectInfoList = data => {
	return service({
		url: '/eproject_log',
		method: 'GET',
		data
	})
};
// 申报奖项
export const EprojectLog = data => {
	return service({
		url: '/eproject_log',
		method: 'POST',
		data
	})
};

export const SaveEDraft = (id, data, project_batch_id) => {
    data.project_id = id;
    data.project_batch_id = project_batch_id;
	return service({
		url: '/eproject_log_temp',
		method: 'POST',
		data:data
	})
};

//保存草稿记录
export const EDraftrecord = (id,project_batch_id,vtid=0) => {
	return service({
		url: '/eproject_log_temp/' + id+'?project_batch_id='+project_batch_id+'&vtid='+vtid,
		method: 'GET'
	})
};
//申报
export const EprojectDeclare = (id, data,rId=null,batchId=null,vtid=null) => {
    data.id = rId;
    data.project_id = id;
    data.project_batch_id = batchId;
    data.log_id = vtid;
	return service({
        url: "/eproject_log",
        method: "POST",
        data:data
    });
};
//申报驳回的
export const EprojectDeclareModify = (rId,id, data,batchId=null) => {
	if(rId&&rId!=0){
	    data.id = rId;
        data.project_id = id;
        data.project_batch_id = batchId;
		return service({
			url: '/eproject_log',
			method: 'POST',
			data: data
		})
	}
	else{
		return EprojectDeclare(id,data,rId,batchId);
	}
};
//申报记录详情
export const EprojectDeclareDetails = (id) => {
	return service({
		url: '/eproject_log/show/' + id,
		method: 'GET'
	})
};
//申报记录删除
export const EprojectDeclareDestory = (id) => {
	return service({
		url: '/eproject_log/destory/' + id,
		method: 'GET'
	})
};

export const EprojectBatches = (data) => {
	return service({
		url: '/expert/eproject/batches',
		method: 'GET',
		data
	})
};

export const AwardBatches = (id) => {
	return service({
		url: '/expert/award/getbatches/'+id,
		method: 'GET'
	})
};

export const echeckedlogs =  (id)  => {
    return service({
        url: '/expert/award/checkedlogs/'+id,
        method: 'GET'
    })
};

export const gfinfo =  (id,cid)  => {
    return service({
        url: '/award_log/gfinfo/'+id+'?cid='+cid,
        method: 'GET'
    })
};


export const saveopinion =(id ,data) => {
	return service({
		url: '/expert/award/saveopinions/'+id,
		method: 'POST',
		data
	})
};

// ========== 荣誉证书 ==========
// 我的荣誉证书汇总（按奖项统计）
export const CertificateSummary = (data) => {
	return service({
		url: '/certificate/summary',
		method: 'GET',
		data
	})
};
// 我的证书列表
export const CertificateList = (data) => {
	return service({
		url: '/certificate',
		method: 'GET',
		data
	})
};
// 证书在线预览 (返回PDF blob, 需用window.open或iframe)
export const CertificatePreviewUrl = (id) => {
	let baseURL = process.env.NODE_ENV == 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home';
	return baseURL + '/certificate/preview/' + id + '?token=' + localStorage.getItem('TOKEN');
};
// 公示期证书预览（基于申报记录）
export const AwardLogPreviewUrl = (awardLogId) => {
	let baseURL = process.env.NODE_ENV == 'development' ? 'https://test-dev.welamp.cn/api/home' : '/api/home';
	return baseURL + '/award_log/preview/' + awardLogId + '?token=' + localStorage.getItem('TOKEN');
};
// 证书详情（用于展示证书类型）
export const CertificateDetail = (id) => {
	return service({
		url: '/certificate/' + id,
		method: 'GET',
	});
};
// 证书类型列表（按奖项）
export const CertificateTypes = (awardId) => {
	return service({
		url: '/certificate/types',
		method: 'GET',
		data: awardId ? { award_id: awardId } : {},
	});
};
// 下载证书（需手机验证码）
export const CertificateDownload = (id, data) => {
	return service({
		url: '/certificate/download/' + id,
		method: 'POST',
		data
	})
};
// 申报记录修改申请
export const SubmitModifyRequest = (awardLogId, data) => {
	return service({
		url: '/award_log/submit_modify_request/' + awardLogId,
		method: 'POST',
		data
	})
};
// 申报记录审核日志
export const AwardLogCheckedLogs = (id) => {
	return service({
		url: '/award_log/checkedlogs/' + id,
		method: 'GET'
	})
};
// 发送下载验证码（复用已有发送验证码接口）
export const SendDownloadSms = (phone, certificateId) => {
	return service({
		url: '/certificate/send_sms',
		method: 'POST',
		data: { phone, certificate_id: certificateId, type: 'certificate_download' }
	})
};
